import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaVimeoV,
} from "react-icons/fa";
import MenuWidget from "../Widget/MenuWidget";
import "./Footer.css";

const menuDataOne = [
  { title: "Home", href: "/" },
  { title: "About", href: "/about" },
  { title: "Services", href: "/service" },
  { title: "Products", href: "/products" },
  { title: "Business Franchise", href: "/franchise" },
  { title: "Contact", href: "/contact" },
  { title: "Refund Policy", href: "/refund-policy" },
  { title: "Terms & Conditions", href: "/term-condition" },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">

        {/* === TOP SECTION === */}
        <div className="footer-top">
          <div className="footer-contact">
            <h3>Call Support 24/7</h3>
            <h2>
              <a href="tel:+919152023390" style={{ color: "inherit", textDecoration: "none" }}>
                +91 91520 23390
              </a>
            </h2>
          </div>

          <div className="footer-logo">
            <img
              src="/images/Riyansh solar logo.png"
              alt="Riyansh Solar Logo"
            />
          </div>

          <div className="footer-contact text-end">
            <h3>Send Email</h3>
            <h2>
              <a href="mailto:Info@riyanshsolar.com">
                Info@riyanshsolar.com
              </a>
            </h2>
          </div>
        </div>

        {/* === MAIN SECTION === */}
        <div className="footer-main">
          <div className="footer-about">
            <p>
              Powering Homes & Businesses with Reliable, Sustainable, and
              Affordable Energy for a Greener Future.
            </p>
                          <h4>Social Links</h4>
            <div className="social-links">
                         <Link to="https://www.facebook.com/riyanshsolarpowerplus" target="blank"><FaFacebookF /></Link>
                         <Link to="/" target="blank"><FaTwitter /></Link>
                         {/* <Link to="/" target="blank"><FaVimeoV /></Link> */}
                         <Link to="https://www.instagram.com/official_riyanshsolarpowerplus/#" target="blank"><FaInstagram /></Link>
            </div>
          </div>

          <div className="footer-menu">
            <MenuWidget data={menuDataOne} title="Quick Links" />
          </div>

          <div className="footer-address">
            <h4>Contact Us</h4>
            <p>
              Office No 3, Venkatesh Plaza, Balaji Nagar, Station Road,
              Bhayandar West, Thane – 401101, Maharashtra
            </p>
          </div>
        </div>
      </div>

      {/* === COPYRIGHT === */}
      <div className="footer-bottom">
        <p>
          ©{new Date().getFullYear()} | All rights reserved by{" "}
          <Link to="/">Riyansh Solar Power</Link>
        </p>
      </div>
    </footer>
  );
}
